import { isAdmin } from './isAdmin';
import { isRequester } from './isRequester';
import { isVisitor } from './isVisitor';

export type CadernoLpmaFormEditFlags = {
	canEditDadosPrincipais: boolean;
	canEditOutrasAbas: boolean;
	canView: boolean;
	canMutate: boolean;
	isVisitante: boolean;
	isRequisitante: boolean;
	isAdmin: boolean;
};

/**
 * Alinhado a Basf.Pdr.Domain.Security.SecurityRoles.CadernoLPMA e ao CadernoLpmaPermissionGuard.
 * Admin: tudo (inclui dados principais e criar).
 * Requisitante: demais abas em cadernos em que é RT ou Assistente (escopo no backend).
 * Visitante: visualização/downloads em cadernos em que é Técnico Principal (escopo no backend).
 */
export function getCadernoLpmaFormEditFlags(roles: string[] | undefined | null): CadernoLpmaFormEditFlags {
	const r = roles ?? [];
	const admin = isAdmin(r);
	const requisitante = isRequester(r);
	const visitante = isVisitor(r);

	return {
		isAdmin: admin,
		isRequisitante: requisitante,
		isVisitante: visitante,
		canEditDadosPrincipais: admin,
		canEditOutrasAbas: admin || requisitante,
		canView: admin || requisitante || visitante,
		canMutate: admin || requisitante,
	};
}

/** Só admin cria caderno (dados principais); requisitante edita apenas cadernos já existentes. */
export function canAdicionarCadernoLpma(roles: string[] | undefined | null): boolean {
	const { canEditDadosPrincipais } = getCadernoLpmaFormEditFlags(roles);
	return canEditDadosPrincipais;
}

export function canCopiarCadernoLpma(roles: string[] | undefined | null): boolean {
	return canAdicionarCadernoLpma(roles);
}

export function canAcessarCadernoLpma(roles: string[] | undefined | null): boolean {
	return getCadernoLpmaFormEditFlags(roles).canView;
}
